export type StatisticsPreviewMembershipCtaCopy = {
  title: string;
  description: string;
};

export const STATISTICS_PREVIEW_MEMBERSHIP_URL = 'https://app.sellerbox.io/m/membership';

export const STATISTICS_PREVIEW_MEMBERSHIP_CTA_DEFAULT: StatisticsPreviewMembershipCtaCopy = {
  title: '셀러박스 멤버십 이용하기',
  description: '판매 관리를 계속 이용하려면 멤버십을 시작하세요!',
};

export const getStatisticsPreviewMembershipCtaCopy = (): StatisticsPreviewMembershipCtaCopy =>
  STATISTICS_PREVIEW_MEMBERSHIP_CTA_DEFAULT;

export const buildStatisticsPreviewMembershipUrl = (cplatToken?: unknown): string => {
  const token = typeof cplatToken === 'string' ? cplatToken.trim() : '';

  if (!token) {
    return STATISTICS_PREVIEW_MEMBERSHIP_URL;
  }

  const queryParams = new URLSearchParams({
    cplatToken: token,
  });

  return `${STATISTICS_PREVIEW_MEMBERSHIP_URL}?${queryParams.toString()}`;
};
